/*** IMPORTS FROM imports-loader ***/
var $ = require("jquery");
var jQuery = require("jquery");

'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactDom = require('react-dom');

var _reactDom2 = _interopRequireDefault(_reactDom);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * @param {ReactClass} Target The component that defines `onOutsideEvent` handler.
 * @param {String[]} supportedEvents A list of valid DOM event names. Default: ['mousedown'].
 * @return {ReactClass}
 */

exports.default = function (Target) {
    var supportedEvents = arguments.length <= 1 || arguments[1] === undefined ? ['mousedown'] : arguments[1];

    return function (_React$Component) {
        _inherits(ReactOutsideEvent, _React$Component);

        function ReactOutsideEvent() {
            var _Object$getPrototypeO;

            var _temp, _this, _ret;

            _classCallCheck(this, ReactOutsideEvent);

            for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
                args[_key] = arguments[_key];
            }

            return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_Object$getPrototypeO = Object.getPrototypeOf(ReactOutsideEvent)).call.apply(_Object$getPrototypeO, [this].concat(args))), _this), _this.componentDidMount = function () {
                if (!_this.refs.target.onOutsideEvent) {
                    throw new Error('Component does not define "onOutsideEvent" method.');
                }

                supportedEvents.forEach(function (eventName) {
                    window.addEventListener(eventName, _this.handleEvent, false);
                });
            }, _this.componentWillUnmount = function () {
                supportedEvents.forEach(function (eventName) {
                    window.removeEventListener(eventName, _this.handleEvent, false);
                });
            }, _this.handleEvent = function (event) {
                var isInside = undefined,
                    isOutside = undefined,
                    target = undefined,
                    targetElement = undefined;

                target = _this.refs.target;
                targetElement = _reactDom2.default.findDOMNode(target);
                isInside = targetElement.contains(event.target) || targetElement === event.target;
                isOutside = !isInside;

                if (isOutside) {
                    target.onOutsideEvent(event);
                }
            }, _temp), _possibleConstructorReturn(_this, _ret);
        }

        _createClass(ReactOutsideEvent, [{
            key: 'render',
            value: function render() {
                return _react2.default.createElement(Target, _extends({ ref: 'target' }, this.props));
            }
        }]);

        return ReactOutsideEvent;
    }(_react2.default.Component);
};

module.exports = exports['default'];
//# sourceMappingURL=index.js.map




//////////////////
// WEBPACK FOOTER
// ./~/react-outside-event/dist/index.js
// module id = 1547
// module chunks = 60